import React from 'react';
import { View } from 'react-native';

import TouchableElement from '@components/common/touchableElement';
import ActionMenu from '@components/common/actionMenu';
import { scale, notchTop } from '@components/frame';
import { setIsMachinesSelectModalOpen } from '@reducers/machinesV2';
import { connect } from 'react-redux';

const MachinesSelectModal = (props) => {
  const { C, machines, selectedMachine, setSelectedMachine, setIsMachinesSelectModalOpen, panelViewMode } = props;

  const items = machines.map((machine) => {
    return {
      lable: {
        color: 'Label/Light/Primary',
        name: machine.shortName,
      },
      icon:
        selectedMachine?.id === machine.id
          ? {
              name: 'check',
              width: 12,
              height: 12,
              color: 'Button/Light/Primary',
            }
          : {
              name: 'check',
              width: 0,
              height: 0,
              color: 'Button/Light/Primary',
            },
      onPress: () => {
        setIsMachinesSelectModalOpen(false);
        setSelectedMachine(machine);
      },
    };
  });

  return (
    <View
      style={{
        width: '100%',
        height: '100%',
        position: 'absolute',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: C('Overlay/Light/Dim light'),
      }}
    >
      <TouchableElement
        style={{ width: '100%', height: '100%', alignItems: 'center' }}
        onPress={() => setIsMachinesSelectModalOpen(false)}
        activeOpacity={1}
      >
        {({ boxStyle }) => (
          <View style={[boxStyle, { width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center', alignContent: 'center' }]}>
            <View
              style={{
                width: '90%',
                position: 'absolute',
                top: notchTop + scale(105) + (panelViewMode ? scale(10) : 0),
                right: scale(panelViewMode ? 70 : 18),
                backgroundColor: C('Background/Light/Field'),
                borderRadius: scale(12),
              }}
            >
              <ActionMenu {...{ C, items }} />
            </View>
          </View>
        )}
      </TouchableElement>
    </View>
  );
};

export default connect(({}) => ({}), { setIsMachinesSelectModalOpen })(MachinesSelectModal);
